import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import useQueryParams from "../../../../auxiliar/customHooks/useQueryParams";
import { classNames } from "../../../../auxiliar/auxFunctions";

const ScreenWithTabs = ({ srTitle, tabs }) => {
    const navigate = useNavigate();
    const params = useQueryParams();
    const activeTab = params.get("tab") || tabs[0].id;
    const containerRef = useRef(null);

    useEffect(() => {
        document.getElementById("overlay").style.display = "none";

        // Scroll to top on route change with improved reliability
        const scrollToTop = () => {
            // Scroll the main scrollable container
            const scrollContainer = document.getElementById("main-scroll-container");
            if (scrollContainer) {
                scrollContainer.scrollTo({ top: 0, behavior: "instant" });
            }

            // Fallback for window scroll
            window.scrollTo({ top: 0, behavior: "instant" });
        };

        // Use setTimeout to ensure DOM is fully updated after route change
        const timeoutId = setTimeout(scrollToTop, 100);

        return () => clearTimeout(timeoutId);
    }, [activeTab]);

    return (
        <div
            ref={containerRef}
            className="xl:container mx-auto xl:p-3 xl:mt-5 xl:mb-12 xl:flex xl:gap-x-16 xl:relative mb-12"
        >
            <h2 className="sr-only">{srTitle}</h2>

            <aside className="flex items-center xl:items-start overflow-x-auto overflow-y-auto border-b border-primary/20 xl:block xl:w-64 xl:flex-none xl:border-0 mb-3 sticky top-0 z-45 h-16 xl:h-auto bg-base-100 xl:fixed xl:top-24">
                <nav className="flex-none px-4 sm:px-6 xl:px-0 mx-auto">
                    <ul className="flex items-center xl:items-start gap-x-3 gap-y-1 whitespace-nowrap xl:flex-col xl:w-full">
                        {tabs.map((item) => (
                            <li key={item.name} className="xl:w-full">
                                <span
                                    onClick={() => navigate(`?tab=${item.id}`)}
                                    className={classNames(
                                        activeTab === item.id
                                            ? "bg-primary/15 text-primary"
                                            : "text-primary hover:bg-primary/8 hover:text-primary",
                                        "group flex items-center gap-x-3 rounded-md py-2 pr-3 pl-2 text-sm/6 font-semibold cursor-pointer xl:w-full",
                                    )}
                                >
                                    <FontAwesomeIcon
                                        icon={item.icon}
                                        className={classNames(
                                            activeTab === item.id
                                                ? "text-primary"
                                                : "text-primary/40 group-hover:text-primary",
                                            "size-6 shrink-0",
                                        )}
                                    />
                                    <span className="hidden xl:block">{item.name}</span>
                                    <span className="hidden md:block xl:hidden">
                                        {item.smallName}
                                    </span>
                                </span>
                            </li>
                        ))}
                    </ul>
                </nav>
            </aside>

            <div className="sm:container w-full mx-auto p-3 xl:p-0">
                <section className="sm:px-3 xl:flex-auto xl:px-0 xl:ml-72">
                    {tabs.find((item) => item.id === activeTab)?.component}
                </section>
            </div>
        </div>
    );
};

export default ScreenWithTabs;
